import { useMemo } from 'react';

function useMetaTags(tagsCallback, dependencies = []) {
  return useMemo(() => {
    return tagsCallback().filter((element) => Boolean(element));
  }, dependencies);
}

export default useMetaTags;
